<canvas width="{{canvasWidth}}" height="{{canvasHeight}}" #circleCanvas></canvas>
